module.exports = __webpack_public_path__ + "static/sima_sticker_rotated-b6dd81b91d49a7141e372381dc2a66e8.png";